import React, { useState } from 'react'
import AccediForm from '../../components/Forms/AccediForm/AccediForm'
import CompleteProfileForm from '../../components/Forms/CompleteProfileForm/CompleteProfileForm'

const AccediPage = () => {
  const [completeProfile, setCompleteProfile] = useState(null);

  const handlecompleteProfile = (data) => {
    console.log("DATA: " + data);
    if(data?.username) {
      setCompleteProfile(data)
    } else {
      setCompleteProfile(null)
    }
  }

  return (
    <div className='my-5'>
      {
        !completeProfile?.username ?
        <AccediForm fetchCompleteProfile={handlecompleteProfile}/>
        :
        <CompleteProfileForm fetchCompleteProfile={completeProfile} setCompleteProfile={setCompleteProfile}/>
      }
    </div>
  )
}

//NEW
var url_string = window.location.href; 
var url = new URL(url_string);
var idSP = url.searchParams.get("id_sp");
localStorage.setItem("idSP", idSP);

export default AccediPage